import React, { useEffect, useState } from "react";
import { Alert, Box, Snackbar, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslate } from "src/locales";
//IDOGAN;446144;04032025
function MotherFallRiskAssessment() {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");

  const showAlert = (
    message: string,
    severity: "error" | "warning" | "info" | "success"
  ) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  useEffect(() => {
    //medcardService.create('data1',5);
    //medcardService.delete('data2',5);
    //medcardService.save('data3',5);
  }, []);

  const handleCreateMedcardData = async () => {
    try {
      //const response = medcardService.create('data',5);
      const response = "Medcard Eklendi";
      console.log("Create API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Create API Hatası:", error);
      showAlert("Medcard eklenirken hata oluştu!", "error");
    }
  };

  const handleSaveMedcard = async () => {
    try {
      //const response = medcardService.save('data',5);
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      //const response = medcardService.delete('data',5);
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };

  const { t } = useTranslate();
  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <ByzMuiButton variant="contained" onClick={handleSaveMedcard}>
          <CheckIcon />
          <ByzMuiTypography ml={0.5} fontSize={13}>
            {t("buttons.save")}
          </ByzMuiTypography>
        </ByzMuiButton>

        <ByzMuiButton variant="contained" onClick={handleDeleteMedcard}>
          <DeleteIcon />
          <ByzMuiTypography ml={0.5} fontSize={13}>
            {t("buttons.delete")}
          </ByzMuiTypography>
        </ByzMuiButton>
        <ByzMuiButton variant="contained" onClick={handleCreateMedcardData}>
          <AddIcon />
          <ByzMuiTypography ml={0.5} fontSize={13}>
            {t("buttons.add")}
          </ByzMuiTypography>
        </ByzMuiButton>
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={6} xs={6} container direction={"column"} spacing={3}>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("mother-fall-risk-assessment.mother-fall")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  paddingRight: "10px",
                  display: "flex",
                }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("datetime")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("createdby")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  disabled
                  label={t("createdby")}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("mother-fall-risk-assessment.parameters")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("mother-fall-risk-assessment.medical-history")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Tıbbi Öyküsü"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("open-process-menu.select")}
                  placeholder={t("open-process-menu.select")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("mother-fall-risk-assessment.emotional-perception")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Duygusal Algı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("open-process-menu.select")}
                  placeholder={t("open-process-menu.select")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("mother-fall-risk-assessment.conditions-regarding-birth")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Doğum İle İlgili Koşullar"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("open-process-menu.select")}
                  placeholder={t("open-process-menu.select")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("mother-fall-risk-assessment.movement")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Hareket"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("open-process-menu.select")}
                  placeholder={t("open-process-menu.select")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("mother-fall-risk-assessment.drug-use")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="İlaç Kullanımı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("open-process-menu.select")}
                  placeholder={t("open-process-menu.select")}
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>{t("other")}</ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("score")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label={t("score")}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("note")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  label="Not"
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Snackbar
              open={alertOpen}
              autoHideDuration={5000}
              onClose={() => setAlertOpen(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert
                onClose={() => setAlertOpen(false)}
                severity={alertSeverity}
                sx={{ width: "100%" }}
              >
                {alertMessage}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default MotherFallRiskAssessment;
